<template>
  <v-layout row>
    <v-flex xs12>
      <v-card flat>
        <v-list three-line :class="{'subscription-expired': isParent && subscriptionExpired}">
          <v-list-tile
            v-for="(item, index) in items"
            :key="`chat_${item.id}`"
            @click="handleClick(item)"
          >
            <v-list-tile-action v-if="selectable" @click.stop="$event.stopPropagation()">
              <v-checkbox v-model="selected" style="margin-top: 12px" :value="item.id" :ripple="false"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-action>
              <div style="width: 100%; height: 56px">
                <app-avatar v-if="item.user.role === 'parent'" :initials="item.user.initials()"></app-avatar>
                <app-avatar v-else-if="item.user.role === 'superadmin'" :src="`/static/img/logo/NG_LOGO-149x149.png`"></app-avatar>
                <app-avatar v-else :src="item.getAvatarRoom($auth.user().id)"></app-avatar>
              </div>
            </v-list-tile-action>

            <v-list-tile-content class="pl-3">
              <v-list-tile-title>
                <div class="d-flex">
                  <div class="primary--text font--medium text-small">{{ item.user.first_name }}</div>
                  <v-spacer></v-spacer>
                  <div class="text--grey_1 font--light text-xs-right text-small">{{ formatCreatedAt(item.created_at)}}</div>
                </div>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary" :class="{'font--light': item.is_read, 'font--medium': !item.is_read}">
                <div v-if="!item.checkType('file')">
                  {{ item.message }}
                </div>
                <div v-else class='sc-message--file-icon'>
                  <a :href="item.image.path || '#'" target='_blank'>
                    <v-img :src="item.image.path" max-width="140" class="elevation-3">
                      <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-layout>
                    </v-img>
                  </a>
                </div>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <div v-if="!item.is_read" class="dot"></div>
              <app-svg-icon v-else name="brand/NG_REPLY" width="28" color="var(--charcoal)"></app-svg-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 < items.length" class="mx-3 border--grey_3"></v-divider>
        </v-list>
      </v-card>
    </v-flex>

    <!-- Dialog for user disabled popup -->
    <v-dialog v-model="showDisabledDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">User Disabled</v-card-title>
        <v-card-text>
          This user is disabled and cannot be contacted.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showDisabledDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import AppAvatar from '../../app-avatar'
import Moment from 'moment/moment'

export default {
  name: 'app-list-inbox',
  components: { AppAvatar },
  props: {
    value: Array,
    selectable: Boolean,
    items: Array,
    default: () => []
  },

  data () {
    return {
      selected: this.value,
      isParent: this.$auth.user().role === 'parent',
      subscriptionExpired: this.$auth.user().subscription ? this.$auth.user().subscription.ended : null,
      showDisabledDialog: false, // State for showing disabled user popup
    }
  },

  watch: {
    selected (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    handleClick (item) {
      if (item.user.is_blocked === 1) {
        // Show popup if user is blocked
        this.showDisabledDialog = true;
      } else {
        // Proceed to chat if user is not blocked
        this.goToChat(item.chat_room_id);
      }
    },
    formatCreatedAt (date) {
      const messageDate = Moment(date);
      const now = Moment();
      if (messageDate.isSame(now, 'day')) {
        return 'Today';
      } else if (messageDate.isSame(now.clone().subtract(1, 'days'), 'day')) {
        return 'Yesterday';
      } else {
        return messageDate.format('MMM D, YYYY');
      }
    },
    goToChat (chatRoomId) {
      this.$router.push(`/chat/${chatRoomId}`);
    }
  }
}
</script>

<style lang="stylus" scoped>
.dot
  border-radius 50%
  width: 10px
  height: 10px
  background-color: var(--green)

.v-list
  > div
    padding 16px 0 !important
.v-list__tile__action
  @media (max-width 600px)
    display none
</style>



// WEBPACK FOOTER //
// src/components/app-lists/inbox/app-list-inbox.vue